import { useFlags } from 'launchdarkly-react-client-sdk';

import { useUserProducts } from '../overview/use-user-products';
import { ProductEditorialContent, useGetEditorialContentQuery } from '@phoenix/team-m/dashboard/frontend/domain/generated/graphql';
import { useQueryContextMemo } from '@phoenix/team-m/dashboard/frontend/shared/use-query-context-memo';
import { useCore } from '@phoenix/core/frontend/shared/feature/context/core.context';

const isEditorialContentCategory = (category: string) =>
  [
    'Brushcutter',
    'Chainsaw',
    'Battery',
    'BackpackBlower',
    'Blower',
    'HedgeTrimmer',
    'HighPressureCleaner',
    'LawnMower',
    'RobotMower',
    'BatteryCharger',
  ].includes(category);

export const useEditorialContent = () => {
  const {
    auth: { user },
  } = useCore();

  const stihlId = user?.stihl_id || '';
  const { 'editorial-content': flagEnabled } = useFlags();

  const { userProductsCategories } = useUserProducts();
  const editorialContentCategories = userProductsCategories?.filter(isEditorialContentCategory) || [];

  const [{ data, fetching, error }, refetch] = useGetEditorialContentQuery({
    variables: { stihlId, productTypes: editorialContentCategories },
    pause: !stihlId || !flagEnabled || !userProductsCategories?.length,
    context: useQueryContextMemo(process.env.NEXT_PUBLIC_TOOL_SHED_GRAPHQL_BASE_URL),
  });

  const editorialContent = (data?.productEditorialContent?.items.map((item, i) => ({ id: `editorialCard-${i + 1}`, ...item })) ||
    []) as Array<ProductEditorialContent & { id: string }>;

  return { editorialContent, refetch: userProductsCategories?.length ? refetch : undefined, isLoading: (!data && !error) || fetching };
};
